import * as actions from '@store/actions/menuAction';

const INIT_STATE = {
    searchMenuInfo: {
        deviceType: '01',
        aplctnScrenTyCd:'01',
        aplctnTpCd:'01',
        useYn:'01',
        extNtwkUseYn:'01',
        linkMenuYn:'01',
        menuId:'',
        depth:0,
        upMenuId: '',
        vmenuID:'',
        searchDeviceType: '01'        
    },
    resultInfo:{
      result: '' 
    },
    saveMenuInfo: {
      menuId: '', 
      aplctnTpCd: '01',
      aplctnDvcTyCd: '',
      menuNm: '',
      depth: 0,
      menuSortOrd: 0,
      aplctnScrenTyCd: '01',
      aplctnScrenTyCdNm: '',
      linkMenuYn: 'N',
      linkUrlAddr: '',
      extNtwkUseYn: 'Y',
      useYn: 'Y',
      fstRegerEmpno: '',
      fstRegDdtm: '',
      fnlUpdrEmpno: '',
      fnlUpdDdtm: '',
      roleId: '',
      roelCd: '',
      ssoLinkdYn: 'N',
      upMenuId: '',
  },
    detailInfo: null,
    menuList: [],
    menuAllList: [],
    menuInfo: {
        upMenuId: '',     
        menuId: '', 
        aplctnTpCd: '01',
        aplctnDvcTyCd: '',
        menuNm: '',
        depth: 0,
        menuSortOrd: 0,
        aplctnScrenTyCd: '',
        aplctnScrenTyCdNm: '',
        linkMenuYn: '',
        linkUrlAddr: '',
        extNtwkUseYn: '',
        useYn: '',
        fstRegerEmpno: '',
        fstRegDdtm: '',
        fnlUpdrEmpno: '',
        fnlUpdDdtm: '',
        roleId: '',
        roelCd: '',      
        ssoLinkdYn: 'N'     
    },
    searchParams: { 
      page: 1,
      size: 10,
    },
};

const menuReducer = (state = INIT_STATE, action) => {
  
    switch (action.type) {      

      case 'GET_APPLICATION_FIRST_MENU_LIST':  
      
         return {
            ...state,            
            menuList: action.payload,
             
      };

      case 'GET_MENU_LIST':  
      
         return {
            ...state,            
            menuAllList: action.payload,
             
      };

      case 'GET_MENU_LIST_SUCCESS':
        return {
          ...state,
          menuAllList: action.payload.RSLT_DATA
          
      };
        
      case 'GET_APPLICATION_MENU_LIST':
  
         return {
            ...state,            
            menuList: action.payload,
             
      };

      case 'GET_APPLICATION_MENU_LIST_SUCCESS':
       
        return {
          ...state,
          menuList: action.payload.RSLT_DATA,          
          detailInfo: action.payload.detail,
          searchMenuInfo: {
            ...state.searchMenuInfo,
            menuId : action.payload.RSLT_DATA.menuId,
            depth : action.payload.RSLT_DATA.depth
          } 
      };

       case 'SAVE_APPLICATION_MENU':
         return {
            ...state,
            menuInfo: { ...state.menuInfo, ...action.payload },
        };

       case 'GET_APPLICATION_MENU_DETAIL':
         return {
            ...state,
            menuInfo: {...action.payload}
         };

       case 'GET_APPLICATION_MENU_DETAIL_SUCCESS':
        return {
          ...state,
          menuInfo: action.payload.RSLT_DATA,

      };    

      case 'UPDATE_SEARCH_MENU_INFO':
         return {
           ...state,
           searchMenuInfo: {
            ...state.searchMenuInfo ,
            ...action.payload,
          },
      };
      
      case 'GET_APPLICATION_MENU_EXCELDOWN':
         return {
           ...state        
      };     

      case 'UPDATE_MENU_INFO':        
         return {
           ...state,
           menuInfo: {
            ...state.menuInfo,
            ...action.payload,
          },
      };

     case 'SAVE_MENU_INFO':
        return {
          ...state,
          saveMenuInfo: {
           ...state.saveMenuInfo,
           ...action.payload,
         },
     };

     case 'DEL_APPLICATION_MENU':
        return {
          ...state,
          menuInfo: {
           ...state.menuInfo,
           ...action.payload,
         },
     };

    case 'UPDATE_SAVE_MENU_INFO_CLEAR':
      return {
        ...state,
        saveMenuInfo: INIT_STATE.saveMenuInfo,
        menuInfo: INIT_STATE.menuInfo
    };

    case 'SAVE_APPLICATION_MENU_UPDOWN':        
        return {
          ...state,
          menuInfo: { 
            ...state.menuInfo, 
            ...action.payload,
            menuSortOrd : action.payload.order
         },
    };

    case 'GET_APPLICATION_MENU_LIST_SORT':
  
      return {
         ...state,            
         menuList: action.payload,
          
   };

   case 'GET_APPLICATION_MENU_LIST_SORT_SUCCESS':
    
     return {
       ...state,
       menuList: action.payload.RSLT_DATA
   };  


   case 'UPDATE_SEARCH_MENU_INFO_CLEAR':      
    return {
      ...state,      
      searchMenuInfo: {
        ...state.searchMenuInfo,
        deviceType : INIT_STATE.searchMenuInfo.deviceType        
      } 
    };

    default:
       return state;
    }

};

export default menuReducer;